import * as moment from 'moment';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SalesPortalService } from 'src/app/services/sales-portal.service';

@Component({
  selector: 'workshop-acquisition',
  templateUrl: './workshop-acquisition.component.html',
  styleUrls: ['./workshop-acquisition.component.less'],
})
export class WorkshopAcquisitionComponent implements OnInit {
  targetYear: string = '';
  searchFormData!: FormGroup;
  isSpinning: boolean = false;
  listOfData: any = [];

  sortFn = {
    targetCustomer: (a: any, b: any) => a.targetCustomer - b.targetCustomer,
    ytdCustomer: (a: any, b: any) => a.ytdCustomer - b.ytdCustomer,
    currentTurnover: (a: any, b: any) => a.actualCustomer - b.actualCustomer,
    stillToGo: (a: any, b: any) => a.customerStillToGo - b.customerStillToGo,
  };

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public salesPortalService: SalesPortalService
  ) {}

  ngOnInit(): void {
    document.body.classList.add('sales-portal-body');
    this.targetYear = String(moment().year());

    this.searchFormData = this.fb.group({
      searchStr: ['', []],
      customerTargetAchieved: ['', []],
    });

    this.getList();
    this.getSummary();
  }

  get scrollX() {
    return window.innerWidth + 200 + 'px';
  }

  ngOnDestroy(): void {
    document.body.classList.remove('sales-portal-body');
  }

  navigate(path: string): void {
    this.router.navigate([path]);
  }

  getList() {
    const params = {
      targetYear: this.targetYear,
      ...this.searchFormData.value,
    };
    this.isSpinning = true;
    this.salesPortalService.dealerTargetList(params).subscribe(
      (result: any) => {
        const { rtnCode, rtnData } = result;
        if (rtnCode === 10000) {
          this.listOfData = rtnData;
        }
        this.isSpinning = false;
      },
      () => {
        this.isSpinning = false;
      }
    );
  }

  getSummary() {
    this.salesPortalService.dealerTargetSummary({
      targetYear: this.targetYear,
      dealerCode: '',
      dealerOrgCode: '',
      dealerChannelCode: '',
    });
  }

  handleDateChange(result: Date) {
    this.targetYear = String(moment(result).year());
    this.getList();
    this.getSummary();
  }

  handleSearch(): void {
    this.getList();
  }

  handleToDetail(data: any) {
    this.router.navigate(['/sales-portal/workshop-acquisition/detail'], {
      queryParams: {
        targetYear: this.targetYear,
        dealerCode: data.dealerCode,
        dealerOrgCode: data.dealerOrgCode,
        dealerChannelCode: data.dealerChannelCode,
      },
    });
  }

  handleToSetting(data: any) {
    this.router.navigate(['/sales-portal/workshop-acquisition/setting'], {
      queryParams: {
        targetYear: this.targetYear,
        dealerCode: data.dealerCode,
        dealerOrgCode: data.dealerOrgCode,
        dealerChannelCode: data.dealerChannelCode,
      },
    });
  }
}
